const sids = [
  'jig',
  'talentpool',
  'edunet',
  'wconat',
  'ncph',
  't4a',
  'edunetke',
  'edunetasia',
  'edunetma',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'ragtp',
  'kle',
  'bbg',
  'wrktp',
  'amseu',
  'coe',
  'jnjtseu',
  'jnjtsat',
  'en',
];
const sidCurses = [
  'jobtalent',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
  'ragtp',
  'kle',
  'en',
  'bbg',
  'wrktp',
  'coe',
];
const sidsIndividualBanner = [
  'edunetke',
  'edunetasia',
  'edunetma',
  'edunetin',
  'kle',
  'en',
  'bbg',
  'coe',
];

const sidsProfessionQueryTsp = [
  'jnjts',
  'jnjtseu',
  'jnjtsat',
];

const sidsNewProfileConsultant = [
  'wrktp',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
];

const sidsEnabledChat = [
  'wrktp',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
  'coe',
  'kle',
  'en',
  'bbg',
];

const sidsIframeCabinetConsultant = [
  'coe',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
];

const sidsCompanyQuery = [
  'kle',
  'en',
  'bbg',
  'coe',
];
const sidsFontTemplate = [
  'talentpool',
  'edunet',
  'edunetke',
  'edunetasia',
  'edunetma',
  'wconat',
  'ncph',
  't4a',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'jnjtseu',
  'jnjtsat',
  'kle',
  'en',
  'bbg',
  'wrktp',
  'amseu',
  'coe',
];
const sidsNewCabinet = [
  'aba',
  'abatest',
  'talentpool',
  'jig',
  'edunet',
  'edunetke',
  'edunetasia',
  'edunetma',
  'wconat',
  'ncph',
  't4a',
  'kh',
  'rhh',
  'he',
  'jobtalent',
  'edunetin',
  'jnjts',
  'wrktp',
  'amseu',
  'coe',
  'kle',
  'en',
  'bbg',
  'jnjtseu',
  'jnjtsat',
];

const sidsLocationCountryFilter = [
  'jnjts',
  'jnjtseu',
  'jnjtsat',
  'wrktp',
];

export const group = (sid: string) => sids.includes(sid);
export const individualBannerGroup = (sid: string) => sidsIndividualBanner.includes(sid);
export const groupCurses = (sid: string) => sidCurses.includes(sid);
export const groupProfessionQueryTsp = (sid: string) => sidsProfessionQueryTsp.includes(sid);
export const groupNewProfileConsultant = (sid: string) => sidsNewProfileConsultant.includes(sid);
export const groupEnabledChat = (sid: string) => sidsEnabledChat.includes(sid);
export const groupIframeCabinetConsultant = (sid: string) => sidsIframeCabinetConsultant.includes(sid);
export const groupCompanyQuery = (sid: string) => sidsCompanyQuery.includes(sid);
export const groupFontTemplate = (sid: string) => sidsFontTemplate.includes(sid);
export const groupNewCabinet = (sid: string) => sidsNewCabinet.includes(sid);
export const groupLocationCountryFilter = (sid: string) => sidsLocationCountryFilter.includes(sid);
